import { createStatusContext } from "./StatusContext"

export enum APP_STATUSES {
    survey = "survey",
    not_found_page = "not_found_page",
    survey_results = "survey_results",
    profile = "profile",
    search_page = "search_page",
    results_from_email = "results_from_email",
    list = "list",
    booking = "booking",
    booking_details = "booking_details",
    payment = "payment",
    psychologist_account = "psychologist_account",
    client_authorization = "client_authorization",
    client_account = "client_account",
    psy_collection = "psy_collection",
    error = "error",
    funnel_docs = "funnel_docs",
    client_card_attachment = "client_card_attachment",
    free_psys_page = "free_psys_page",
    video_call_page = "video_call_page",
    internal_call_page = "internal_call_page",
    video_hangup_page = "video_hangup_page",
}

export const {
    StatusProvider: AppStatusProvider,
    StatusContext: AppStatusContext,
    useStatusContext: useAppStatusContext,
} = createStatusContext<APP_STATUSES>()
